import { Button, ButtonProps, Text } from '@cmpsr/components';
import SubmitAccentButton from '../submit-accent-button/submit-accent-button';

type VerifyEmailFooterProps = ButtonProps & {
  buttonProps: ButtonProps;
  textButton: string;
  color?: string;
  showResend: boolean;
  onClick: () => void;
  countdown: number;
};

export default function VerifyEmailFooter({
  buttonProps,
  textButton,
  color,
  showResend,
  onClick,
  countdown,
}: VerifyEmailFooterProps) {
  return (
    <>
      <SubmitAccentButton size="l" {...buttonProps}>
        {textButton}
      </SubmitAccentButton>
      <Text variant="text-body-meta-regular" w="100%" textAlign="center" color={color}>
        Didn't get the code?{' '}
        {showResend ? (
          <Button variant="link" textDecoration="underline" onClick={onClick}>
            Resend code
          </Button>
        ) : (
          `You can request a new one in ${countdown}s`
        )}
      </Text>
    </>
  );
}
